import Vue from 'vue';

Vue.filter('rightPad', (value, size, filling) => {
    if (value === null || value === undefined) { value = ''; }

    value = value + '';

    return value.padEnd(size, filling);
});